import React from 'react';
import { Text, Stack, Box } from '@mantine/core';
import styles from './empty-notification.module.scss';
import Image from 'next/image';
import { useSelector } from 'react-redux';

const EmptyNotification = () => {

    const { languageData } = useSelector((state) => state.language);
    const notifications = languageData?.text?.notifications;
    return (
        <Box className={styles.empty_container}>
            <Stack align="center" spacing="md">
                <div className={styles.icon_wrapper}>
                    <Image src="/images/icons/notification.svg" width={28} height={28} alt="notification" />
                </div>
                <div className={styles.content_wp}>
                    <p className={styles.title}>{notifications?.title}</p>
                    <Text size="sm" color="dimmed" className={styles.description}>
                        {notifications?.message}
                    </Text>
                </div>
            </Stack>
        </Box>
    );
};

export default EmptyNotification;
